import VDataTable from 'vuetify/es5/components/VDataTable/VDataTable'
import _VCheckbox2 from 'vuetify/es5/components/VCheckbox/VCheckbox'
import { createSimpleFunctional } from 'vuetify/es5/util/helpers'
import { dragscroll } from 'vue-dragscroll'

const HEADERS_HEIGHT = 56
const VTableOverflow = (0, createSimpleFunctional)('v-table__overflow')
export default {
  name: 'data-table-new',
  extends: VDataTable,
  props: {
    dragscroll: {
      type: Boolean,
      default: false,
    },
    customHeaders: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    dragscroll: dragscroll,
  },
  methods: {
    genTHead: function genTHead() {
      const _this = this

      if (this.hideHeaders) return // Exit Early since no headers are needed.
      let children = []
      if (this.customHeaders && this.$scopedSlots.headers) {
        const row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.everyItem,
        })
        children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()]
      } else {
        const _row = this.headers.map(function (o, i) {
          return _this.genHeader(o, _this.headerKey ? o[_this.headerKey] : i)
        })
        const checkbox = this.$createElement(_VCheckbox2.default, {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true ? '' : this.selectAll,
            hideDetails: true,
            inputValue: this.everyItem,
            indeterminate: this.indeterminate,
          },
          on: { change: this.toggle },
        })
        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]))
        children = [this.genTR(_row), this.genTProgress()]
      }
      return this.$createElement(
        'thead',
        {
          directives: [
            {
              name: 'dragscroll',
              value: this.$props.dragscroll,
            },
          ],
          on: {
            dragscrollmove: function (e) {
              this.$emit('dragscrollmove', e.detail)
            }.bind(this),
            dragscrollend: function (e) {
              this.$emit('dragscrollend', e.detail, e.timeStamp)
            }.bind(this),
            dragscrollstart: function (e) {
              this.$emit('dragscrollstart', e.detail, e.timeStamp)
            }.bind(this),
            '!click': function (e) {
              this.$emit('dragscrollclick', e, e.timeStamp)
            }.bind(this),
          },
          ref: 'thead',
        },
        [children],
      )
    },
    // Returning boolean dependent on success or failure of calculating values
    recalcParams: function () {
      // Check if table is actually visible on page
      if (this.$refs.table.clientWidth === 0) return false
      const _mem = this.headerPosition
      const _mem1 = this.tableContentWidth
      const rect = this.$refs.table.getBoundingClientRect()
      const bottomPosition = rect.bottom - this.toolbarHeight - HEADERS_HEIGHT
      if (rect.width && rect.width > 0) {
        if (rect.top <= this.toolbarHeight) {
          if (bottomPosition <= 0) {
            this.headerPosition = rect.height - HEADERS_HEIGHT
          } else {
            this.headerPosition = -rect.top + this.toolbarHeight
          }
        } else {
          this.headerPosition = 0
        }
      }
      this.tableContentWidth = rect.width
      if (_mem !== this.headerPosition) this.$emit('headerPositionChanged', this.headerPosition)
      if (_mem1 !== this.tableContentWidth) this.$emit('tableContentWidthChanged', this.tableContentWidth)
      return true
    },
  },

  mounted() {
    this.rendered = false
    this.headerPosition = 0
    this.tableContentWidth = 0
    window.addEventListener('scroll', this.recalcParams)
    // First time appearing just checking if everything is loaded and then recalculating
    // but recalculating might have been unsuccessful due to invisibility of component
    // it might have been rendered on hidden block or something
    // since its not possible to reactively know when it becomes visible
    // there is need to use interval
    this.INTERVAL = setInterval(() => {
      if (this.rendered) {
        if (this.recalcParams()) {
          clearInterval(this.INTERVAL)
        }
      } else {
        // In some cases updated hook not triggered at all
        // so we force it to proceed
        this.$forceUpdate()
      }
    }, 1000)
  },
  updated() {
    if (!this.rendered) {
      if (this.$refs.table && this.$refs.thead) {
        this.$nextTick(() => {
          const toolbar = document.querySelector('.pl-toolbar')
          if (toolbar && toolbar.classList.contains('v-toolbar--fixed')) {
            this.toolbarHeight = toolbar.getBoundingClientRect().height
          }
          this.rendered = true
        })
      }
    } else {
      // Once something inside is updated we need to recalculate values
      // since we cant really know when element will become visible
      // we assume that it becomes visible at some point and
      // relaying on this interval to check for it
      clearInterval(this.INTERVAL)
      this.INTERVAL = setInterval(() => {
        if (this.rendered) {
          if (this.recalcParams()) {
            clearInterval(this.INTERVAL)
          }
        }
      }, 1000)
    }
  },
  destroyed() {
    this.$nextTick(() => {
      window.removeEventListener('scroll', this.recalcParams)
      clearInterval(this.INTERVAL)
    })
  },
  render: function render(h) {
    const tableOverflow = h(VTableOverflow, {}, [
      h(
        'table',
        {
          class: this.classes,
          ref: 'table',
        },
        [this.genTHead(), this.genTBody(), this.genTFoot()],
      ),
    ])
    return h('div', [tableOverflow, this.genActionsFooter()])
  },
}
